import { tempMeeApi } from '~/services/api';
import { scopedHeaders } from '~/services/scopedHeaders';
import {
  IAddCardRequest,
  IConnectPlaidRequest,
  IFinalizePlaidVerifyPayload,
  IMintConnectLinkTokenResponse,
  IMintVerifyLinkTokenPayload,
  IMintVerifyLinkTokenResponse,
  TPaymentMethodsResponse,
} from './types';

// Every call takes an optional `officeId`: the location whose billing it is, sent
// as its `x-office` over the selected office's (Billing Details opened from a
// location, GOTU-19472). Without it the request is the selected office's.

export const getPaymentMethods = async (officeId?: string): Promise<TPaymentMethodsResponse> => {
  const headers = await scopedHeaders(officeId);
  const response = await tempMeeApi.get<TPaymentMethodsResponse>(
    '/payment/account/payment-method/',
    { headers },
  );

  return response.data;
};

export const mintConnectLinkToken = async (
  officeId?: string,
): Promise<IMintConnectLinkTokenResponse> => {
  const headers = await scopedHeaders(officeId);
  const response = await tempMeeApi.post<IMintConnectLinkTokenResponse>(
    '/payment/account/plaid/',
    {},
    { headers },
  );

  return response.data;
};

export const connectPlaid = async (body: IConnectPlaidRequest, officeId?: string) => {
  const headers = await scopedHeaders(officeId);
  const response = await tempMeeApi.post('/payment/account/plaid/connect', body, { headers });

  return response.data;
};

export const mintVerifyLinkToken = async (
  { candidateId }: IMintVerifyLinkTokenPayload,
  officeId?: string,
): Promise<IMintVerifyLinkTokenResponse> => {
  const headers = await scopedHeaders(officeId);
  const response = await tempMeeApi.post<IMintVerifyLinkTokenResponse>(
    '/payment/account/plaid/verify-token',
    { candidateId },
    { headers },
  );

  return response.data;
};

export const finalizePlaidVerify = async (
  body: IFinalizePlaidVerifyPayload,
  officeId?: string,
): Promise<null> => {
  const headers = await scopedHeaders(officeId);
  const response = await tempMeeApi.post<null>('/payment/account/plaid/verify', body, { headers });

  return response.data;
};

export const addCard = async (body: IAddCardRequest, officeId?: string) => {
  const headers = await scopedHeaders(officeId);
  const response = await tempMeeApi.post('/payment/account/payment-method/', body, { headers });

  return response.data;
};

export const deletePaymentMethod = async (paymentId: string, officeId?: string): Promise<void> => {
  const headers = await scopedHeaders(officeId);
  await tempMeeApi.delete(`/payment/account/payment-method/${paymentId}`, { headers });
};

export const selectPaymentMethod = async (paymentId: string, officeId?: string): Promise<void> => {
  const headers = await scopedHeaders(officeId);
  await tempMeeApi.patch(`/payment/account/payment-method/${paymentId}`, {}, { headers });
};

export const paymentsApi = {
  getPaymentMethods,
  mintConnectLinkToken,
  connectPlaid,
  mintVerifyLinkToken,
  finalizePlaidVerify,
  addCard,
  deletePaymentMethod,
  selectPaymentMethod,
};
